export interface PasswordValidation {
  isValid: boolean;
  errors: string[];
  strength: "weak" | "medium" | "strong";
}

export function validatePassword(password: string): PasswordValidation {
  const errors: string[] = [];

  if (password.length < 6) {
    errors.push("Must be at least 6 characters");
  }

  if (!/[0-9]/.test(password)) {
    errors.push("Must contain at least one number");
  }

  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
    errors.push("Must contain at least one special character");
  }

  if (!/[A-Z]/.test(password)) {
    errors.push("Must contain at least one uppercase letter");
  }

  if (!/[a-z]/.test(password)) {
    errors.push("Must contain at least one lowercase letter");
  }

  let strength: "weak" | "medium" | "strong" = "weak";
  const passedChecks = 5 - errors.length;

  if (passedChecks >= 5 && password.length >= 10) {
    strength = "strong";
  } else if (passedChecks >= 3) {
    strength = "medium";
  } else {
    strength = "weak";
  }

  return {
    isValid: errors.length === 0,
    errors,
    strength,
  };
}

export function getPasswordStrengthColor(
  strength: "weak" | "medium" | "strong"
): string {
  switch (strength) {
    case "weak":
      return "text-red-500";
    case "medium":
      return "text-yellow-500";
    case "strong":
      return "text-green-500";
  }
}

export function getPasswordStrengthText(
  strength: "weak" | "medium" | "strong"
): string {
  switch (strength) {
    case "weak":
      return "Weak";
    case "medium":
      return "Medium";
    case "strong":
      return "Strong";
  }
}
